<template>
  <div>
    <div class="row no-gutters" v-if="produtos">
      <div class="col-lg-6 px-lg-1" v-for="l in produtos" :key="l.id_produto">
        <a href="javascript:" class="text-dark lista not-decoration" @click="$emit('openProduto', l.id_produto, l.id_categoria)">
          <div class="row no-gutters">
            <div class="col-8 pr-2">
              <h4 class="h6 m-0">
                {{l.nome_produto}} <span class="badge badge-light font-weight-normal text-primary mr-1" v-if="l.is_new === '1'"><i class="fa fa-star"></i> Novo</span>
              </h4>
              <div class="mt-1 text-muted">
                <p class="tamanho-2 m-0 limite" v-html="l.descricao_produto"></p>
                <div class="text-primary mt-1 mb-0 font-weight-bold" v-show="l.divisao === '0'">
                  <del class="d-md-block text-dark small mr-1" v-if="l.valor_base > 0 && l.qtd_tabelas === '1'">{{l.valor_base | valor}}</del>
                  <span class="small" v-if="l.qtd_tabelas > 1">A partir de </span>
                  <span v-if="l.valor > 0">{{l.valor | valor}}</span>
                </div>
                <div class="mt-1" v-if="l.qtd_tabelas === '1' && l.tipo_consumo > 1">
                  <produto-consumo :consumo="l.tipo_consumo" :tipo_pedido="sacola.tipo_pedido"/>
                </div>
              </div>
            </div>
            <div class="col-4 text-right">
              <img :src="l.url_imagem || img_empresa || img_default" :class="{'bg-primary': !l.url_imagem}" aria-hidden="true" :alt="l.nome_produto">
            </div>
          </div>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
  import ProdutoConsumo from "./ProdutoConsumo";
  export default {
    name: 'ListaProdutos',
    components: {ProdutoConsumo},
    props: ['produtos'],
    computed: {
      sacola() {
        return this.$store.state.sacola || {}
      },

      img_empresa() {
        return this.$store.state.empresa.url_imagem
      }
    }
  }
</script>

<style scoped>
  .lista img {
    max-width: 100%;
    width: 100px;
    height: 100px;
    object-fit: cover;
    border-radius: 12px;
  }

  .lista {
    display: block;
    cursor: pointer;
    background-color: #fff;
    border: none;
    min-height: 80px;
    border-radius: 16px;
    margin-bottom: 8px;
    box-shadow: var(--shadow);
    transition-duration: .15s;
    padding: 12px;
  }

  .lista:hover {
    box-shadow: var(--shadow-lg);
  }

  @media (min-width: 768px) {
    .lista {
      margin-bottom: 12px;
      min-height: 132px;
    }

    .lista img {
      width: 90px;
      height: 90px;
    }
  }

  @media (min-width: 993px) {
    .lista img {
      width: 80px;
      height: 80px;
    }
  }

</style>
